// extracted by mini-css-extract-plugin
export var buttonContainer = "_8l-1";
export var fontSizeSelect = "_8l-3";
export var formatSelect = "_8l-2";
export var formats = "_8l-4";
export var hidden = "_8l-5";
export var icon = "_8l-6";
export var select = "_8l-0";